let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fPobZ")).then(() => parcelRequire('aO1kd'));